module.exports = __webpack_public_path__ + "img/10.e523477a.jpg";